// ============================================================
// Gap Scorer Utility
// ============================================================

/**
 * Validity & Feasibility scoring.
 * criteria = { unresolved, contributory, specific, attainable } — each 1-5
 * Returns { total, percentage, verdict, breakdown }
 */
export function scoreValidity(criteria = {}) {
  const keys = ['unresolved', 'contributory', 'specific', 'attainable'];
  const total = keys.reduce((sum, k) => sum + (parseInt(criteria[k], 10) || 0), 0);
  const percentage = Math.round((total / 20) * 100);

  let verdict = '';
  if (percentage >= 80) verdict = 'Strong — Proceed with Confidence';
  else if (percentage >= 60) verdict = 'Moderate — Refine Before Proceeding';
  else if (percentage >= 40) verdict = 'Weak — Significant Revision Needed';
  else verdict = 'Insufficient — Reconsider Gap Selection';

  const breakdown = keys.map((k) => ({
    criterion: k.charAt(0).toUpperCase() + k.slice(1),
    score: parseInt(criteria[k], 10) || 0,
    maxScore: 5,
  }));

  return { total, percentage, verdict, breakdown };
}

/**
 * User confirmation scores per gap type.
 * confirmations = { THEORETICAL: 'yes'|'no'|'unsure', ... }
 * Returns adjusted ranked list.
 */
export function applyUserConfirmation(rankedGaps = [], confirmations = {}) {
  return rankedGaps.map((gap) => {
    const conf = confirmations[gap.type];
    let multiplier = 1;
    if (conf === 'yes') multiplier = 1.3;
    if (conf === 'no') multiplier = 0.2;
    if (conf === 'unsure') multiplier = 0.8;
    return {
      ...gap,
      adjustedScore: Math.round(gap.totalScore * multiplier * 10) / 10,
      userConfirmation: conf || 'not reviewed',
    };
  }).sort((a, b) => b.adjustedScore - a.adjustedScore);
}
